// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";

import "prismjs/themes/prism.css";
import "./src/styles/_toggle.scss";
import "./src/styles/_base.scss";
